module.exports = __webpack_public_path__ + "img/btn_startgame.c1be731c.png";